import script from "./AgentMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentMessage.vue?vue&type=script&setup=true&lang=js"

import "./AgentMessage.vue?vue&type=style&index=0&id=797ac6b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-797ac6b4"]])

export default __exports__